// Web3Auth Libraries
import { EthereumPrivateKeyProvider } from '@web3auth/ethereum-provider';
import {
  CHAIN_NAMESPACES,
  IWeb3AuthCoreOptions,
  WEB3AUTH_NETWORK,
} from '@web3auth/base';
import { AuthAdapter } from '@web3auth/auth-adapter';
import { Web3AuthContextConfig } from '@web3auth/no-modal-react-hooks';

const name = 'Darwin Evolution';
const clientId =
  import.meta.env.VITE_USE_CHAIN === 'polygon'
    ? (import.meta.env.VITE_WEB3_AUTH_CLIENT_ID_PROD as string)
    : (import.meta.env.VITE_WEB3_AUTH_CLIENT_ID_DEV as string);
const verifier =
  import.meta.env.VITE_USE_CHAIN === 'polygon'
    ? (import.meta.env.VITE_WEB3_AUTH_CLIENT_VERIFIER_PROD as string)
    : (import.meta.env.VITE_WEB3_AUTH_CLIENT_VERIFIER_DEV as string);

const chainConfig = {
  logo: 'https://web3auth.io/images/web3authlog.png',
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  chainId: import.meta.env.VITE_USE_CHAIN === 'polygon' ? '0x89' : '0x66eee',
  rpcTarget:
    import.meta.env.VITE_USE_CHAIN === 'polygon'
      ? 'https://polygon-rpc.com'
      : 'https://sepolia-rollup.arbitrum.io/rpc',
  displayName:
    import.meta.env.VITE_USE_CHAIN === 'polygon'
      ? 'Polygon Mainnet'
      : 'Arbitrum Sepolia',
  blockExplorerUrl:
    import.meta.env.VITE_USE_CHAIN === 'polygon'
      ? (import.meta.env.VITE_MATIC_SCAN as string)
      : (import.meta.env.VITE_SEPOLIA_SCAN as string),
  ticker: import.meta.env.VITE_USE_CHAIN === 'polygon' ? 'MATIC' : 'ETH',
  tickerName:
    import.meta.env.VITE_USE_CHAIN === 'polygon'
      ? 'Polygon'
      : 'Arbitrum Sepolia',
};

const privateKeyProvider = new EthereumPrivateKeyProvider({
  config: { chainConfig },
});

const options: IWeb3AuthCoreOptions = {
  clientId,
  chainConfig,
  privateKeyProvider,
  uiConfig: {
    appName: name,
    defaultLanguage: 'en',
    logoLight: 'https://web3auth.io/images/web3authlog.png',
    logoDark: 'https://web3auth.io/images/web3authlogodark.png',
    mode: 'light',
  },
  web3AuthNetwork:
    import.meta.env.VITE_USE_CHAIN === 'polygon'
      ? WEB3AUTH_NETWORK.SAPPHIRE_MAINNET
      : WEB3AUTH_NETWORK.SAPPHIRE_DEVNET,
  enableLogging: true,
  useCoreKitKey: true,
};

const authAdapter = new AuthAdapter({
  adapterSettings: {
    loginConfig: {
      email_passwordless: {
        verifier,
        typeOfLogin: 'email_passwordless',
        clientId,
      },
    },
  },
});

export const web3AuthContextConfig: Web3AuthContextConfig = {
  web3AuthOptions: options,
  adapters: [authAdapter],
};
